import type { HelpArticle } from '../../../components/help/types';

export const bulkImportArticles: HelpArticle[] = [
  {
    id: 'bulk-import-overview',
    title: 'Bulk Import Overview',
    summary: 'Understanding the bulk import feature for large data sets.',
    category: 'bulk-import',
    order: 1,
    keywords: ['bulk', 'import', 'batch', 'upload', 'mass', 'multiple'],
    content: `
# Bulk Import Overview

Import large amounts of data efficiently using bulk import.

## What Can Be Imported?

- **Users**: Staff accounts in bulk
- **Documents**: Multiple files with metadata
- **PFile Records**: Personnel file information

## Import Process

1. **Download Template**: Get the correct format
2. **Fill Data**: Complete the spreadsheet
3. **Validate**: Check for errors
4. **Import**: Upload and process
5. **Review**: Check import results

## Benefits

- Save time on repetitive data entry
- Ensure consistent formatting
- Reduce manual errors
- Import historical records

## Requirements

- Administrator or authorized role
- Data in correct template format
- Valid values for required fields
- Appropriate permissions
    `,
  },
  {
    id: 'bulk-import-users',
    title: 'Importing Users',
    summary: 'How to bulk import user accounts.',
    category: 'bulk-import',
    order: 2,
    keywords: ['users', 'accounts', 'staff', 'import', 'bulk'],
    content: `
# Importing Users

Add multiple user accounts at once using bulk import.

## Getting Started

1. Go to **Admin** > **Users**
2. Click **Bulk Import**
3. Download the template

## Template Fields

Required fields:
- \`email\`: User's email address
- \`firstName\`: First name
- \`lastName\`: Last name
- \`departmentCode\`: Department identifier
- \`roleCode\`: Role to assign

Optional fields:
- \`staffId\`: Staff ID number
- \`phone\`: Phone number
- \`position\`: Job title

## Preparing Your Data

1. Open the template in Excel
2. Fill in user information
3. Ensure emails are unique
4. Match department/role codes exactly
5. Save as CSV or XLSX

## Importing

1. Click **Select File**
2. Choose your prepared file
3. Click **Validate**
4. Review any errors
5. Click **Import**

## After Import

- Users receive welcome emails
- Temporary passwords are generated
- Users must change password on first login

## Common Errors

- Duplicate email addresses
- Invalid department codes
- Missing required fields
- Incorrect role codes
    `,
  },
];
